import Fetch, { V1, V6 } from 'Util/fetcher';
//= =====================================================================================//
//                                    SEARCH FUND DATA                                   //
//= =====================================================================================//

const ON_SEARCH_FUND_DATA = 'ON_SEARCH_FUND_DATA';
const ON_SEARCH_FUND_DATA_FAILURE = 'ON_SEARCH_FUND_DATA_FAILURE';
const ON_SEARCH_FUND_DATA_SUCCESS = 'ON_SEARCH_FUND_DATA_SUCCESS';

function onSearchFundData() {
  return {
    type: 'ON_SEARCH_FUND_DATA',
  };
}

function onSearchFundDataFailure(payload) {
  return {
    type: 'ON_SEARCH_FUND_DATA_FAILURE',
    payload,
  };
}

function onSearchFundDataSuccess(payload) {
  return {
    type: 'ON_SEARCH_FUND_DATA_SUCCESS',
    payload,
  };
}

export const onDoSearchFundData = (payload) => (dispatch) => {
  dispatch(onSearchFundData());
  Fetch.get(`${V1}mutualfund/fund-bundle/search/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        const response = resp.json;
        response.selected = payload;
        dispatch(onSearchFundDataSuccess(response));
      } else {
        dispatch(onSearchFundDataFailure(resp.json));
      }
    })
    .catch((err) => {
      dispatch(onSearchFundDataFailure(err.message));
    });
};

//= =====================================================================================//
//                               SEARCH STOCK DATA                                       //
//= =====================================================================================//

const ON_SEARCH_STOCK_DATA = 'ON_SEARCH_STOCK_DATA';
const ON_SEARCH_STOCK_DATA_FAILURE = 'ON_SEARCH_STOCK_DATA_FAILURE';
const ON_SEARCH_STOCK_DATA_SUCCESS = 'ON_SEARCH_STOCK_DATA_SUCCESS';

function onSearchStockData() {
  return {
    type: 'ON_SEARCH_STOCK_DATA',
  };
}

function onSearchStockDataFailure(payload) {
  return {
    type: 'ON_SEARCH_STOCK_DATA_FAILURE',
    payload,
  };
}

function onSearchStockDataSuccess(payload) {
  return {
    type: 'ON_SEARCH_STOCK_DATA_SUCCESS',
    payload,
  };
}

export const onDoSeachStockData = (payload) => (dispatch) => {
  dispatch(onSearchStockData());
  Fetch.get(`${V6}stock/data/?q=${payload}`)
    .then((resp) => {
      if (resp.ok) {
        const response = resp.json;
        response.selected = payload;
        dispatch(onSearchStockDataSuccess(response));
      } else {
        dispatch(onSearchStockDataFailure(resp.json));
      }
    })
    .catch((err) => {
      dispatch(onSearchStockDataFailure(err.message));
    });
};

//= ===================================================================================//
//                             INITIAL STATE                                           //
//= ===================================================================================//

const INITIAL_STATE = {
  searchFundLoading: null,
  searchFundData: null,
  searchFundError: null,

  searchStockLoading: null,
  searchStockData: null,
  searchStockError: null,
};

const search = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_SEARCH_FUND_DATA:
      return {
        ...state,
        searchFundLoading: true,
        searchFundData: null,
        searchFundError: null,
      };
    case ON_SEARCH_FUND_DATA_SUCCESS:
      return {
        ...state,
        searchFundLoading: false,
        searchFundData: action.payload,
        searchFundError: null,
      };
    case ON_SEARCH_FUND_DATA_FAILURE:
      return {
        ...state,
        searchFundLoading: false,
        searchFundData: null,
        searchFundError: action.payload,
      };
    case ON_SEARCH_STOCK_DATA:
      return {
        ...state,
        searchStockLoading: true,
        searchStockData: null,
        searchStockError: null,
      };
    case ON_SEARCH_STOCK_DATA_SUCCESS:
      return {
        ...state,
        searchStockLoading: false,
        searchStockData: action.payload,
        searchStockError: null,
      };
    case ON_SEARCH_STOCK_DATA_FAILURE:
      return {
        ...state,
        searchStockLoading: false,
        searchStockData: null,
        searchStockError: action.payload,
      };
    default:
      return state;
  }
};

export default search;
